import {useCheckoutStore} from "#sharedMarketplace/features/checkout/stores/checkoutStore";

export function useCheckoutPaymentRedirect() {
  const localePath = useLocalePath();

  const checkoutStore = useCheckoutStore();
  const {paymentData} = storeToRefs(checkoutStore);
  const {stopPolling, clear} = checkoutStore;

  const handle = () => {
    const invoiceId = paymentData.value.invoiceId;
    const url = paymentData.value.url;

    if (paymentData.value.state === 'waiting_for_user') {
      if (paymentData.value.url) {
        if (!paymentData.value.embedded) {
          stopPolling();
          clear();
          window.location = url;
        }
      }
    } else if (paymentData.value.state === 'paid') {
      stopPolling();
      clear();
      navigateTo(localePath(`/invoices/${invoiceId}`));
    } else if (paymentData.value.state === 'not_required') {
      stopPolling();
      clear();
      window.location = url;
    }
  }

  return {
    handle,
  }
}